import { createSelector } from 'reselect'
import curry from 'lodash/fp/curry'
import getOr from 'lodash/fp/getOr'

/** getOrEmptyObject :: String -> Object -> Object */
export const getOrEmptyObject = getOr({})
/** getOrEmptyArray :: String -> Object -> Array */
export const getOrEmptyArray = getOr([])
/** getOrEmptyArray :: String -> Object -> Boolean */
export const getOrFalse = getOr(false)
/** getOrEmptyArray :: String -> Object -> a? */
export const getOrNull = getOr(null)

/** create subStateSelector :: (String -> Fn) -> Fn -> Object -> Object */
export const createSubStateSelector = curry(
  (key, parentSelector) => createSelector(parentSelector, getOrEmptyObject(key))
)

/** createSubStateRequesting :: Fn f -> Fn g -> Object -> Object */
export const createSubStateRequestings = createSubStateSelector('requesting')
/** createSubStateRequesting :: Fn -> Fn -> Object -> Object */
export const createSubStateErrors = createSubStateSelector('error')
/** createSubStateResults :: Fn -> Fn -> Object -> Object */
export const createSubStateResults = createSubStateSelector('results')

/** createIsRequestingSelector :: Fn -> String -> Fn -> Object -> Boolean */
export const createIsRequestingSelector = parentSelector => (key = 'requesting') => createSelector(
  parentSelector,
  getOrFalse(key)
)

/** createSelectorOrNull :: Fn -> String -> Fn -> Object -> a */
export const createSelectorOrNull = parentSelector => key => createSelector(
  parentSelector,
  getOrNull(key)
)

/** createErrorSelector :: Fn -> String -> Fn -> Object -> Error? */
export const createErrorSelector = parentSelector => (key = 'error') => createSelector(
  parentSelector,
  getOrNull(key)
)
/** createResultsSelector :: Fn -> String -> Fn -> Object -> Array */
export const createResultsSelector = parentSelector => (key = 'results') => createSelector(
  parentSelector,
  getOrEmptyArray(key)
)
